import delimg from './images/cross.png';
import ediimg from './images/st5.png';
import comimg from './images/comp.jpeg';
import axios from "axios";
import { useEffect, useState } from "react";
import SideBar from './sidebar';

function Projects()
{
    let [prjData,setPrjData]=useState({sid:0,cid:0,tid:0,sname:"",rdate:"",ddate:"",status:"",prj:{type:"",data:""},trf:{type:"",data:""},raw:{type:"",data:""},rpt:{type:"",data:""}});
    let [tests,setTests]=useState([]);
    let [clients,setClients]=useState([]);
    let [projects,setProjects]=useState([]);  
    function clearText()
    {
        setPrjData({sid:0,cid:0,tid:0,sname:"",rdate:"",ddate:"",status:"",prj:{type:"",data:""},trf:{type:"",data:""},raw:{type:"",data:""},rpt:{type:"",data:""}});
        document.getElementById("raw").value="";
        document.getElementById("trf").value="";
        document.getElementById("prj").value="";
        document.getElementById("rpt").value="";
    }  
    function getTests()
    {
        let config={headers:{"Content-Type":"application/json",}};
        axios.get(process.env.REACT_APP_APIURL+"tests.php").then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setTests(reply.data.data);
            }
        });
    }
    function getClients()
    {
        let config={headers:{"Content-Type":"application/json",}};
        axios.get(process.env.REACT_APP_APIURL+"clients.php").then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setClients(reply.data.data);
            }
        });
    }
    async function getProjects(start,end)
    {
        let config={headers:{"Content-Type":"application/json",}};
        let url=process.env.REACT_APP_APIURL+"samples.php";
        if(start!="" && end !="")
        {
            url=process.env.REACT_APP_APIURL+"samples.php?start="+start+"&end="+end;
        }
        axios.get(url).then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setProjects(reply.data.data);                
            }
        });
    }
    function testChanged(event)
    {
        if(event.target.id=="sname")
        {
            setPrjData({...prjData,sname:event.target.value});
        }
        if(event.target.id=="tname")
        {
            setPrjData({...prjData,tid:event.target.value});
        } 
        if(event.target.id=="cname")
        {
            setPrjData({...prjData,cid:event.target.value});
        }
        if(event.target.id=="rdate")
        {
            setPrjData({...prjData,rdate:event.target.value});
        }
        if(event.target.id=="ddate")
        {
            setPrjData({...prjData,ddate:event.target.value});
        }
        if(event.target.id=="prj")
        {
            if(event.target.files && event.target.files.length>0)
            {
                let size=event.target.files[0].size;
                let name=event.target.files[0].name;
                let type=event.target.files[0].type;
                if(size>=500*1024)
                {
                    alert("File Size should be less than<500KB !!");
                    event.target.value="";
                    return;
                }                
                else if(!(type=="image/jpg" || type=="image/jpeg" || type=="image/png" || type=="application/pdf" || type=="application/msword" || type=="application/vnd.openxmlformats-officedocument.wordprocessingml.document"))
                {
                    alert("Only Word/PDF/JPG/PNG is valid!!!");
                    event.target.value="";
                    return;
                }
                else
                {
                    let fr=new FileReader();
                    fr.onloadend=(e)=>
                    {
                        let data=fr.result;
                        let idx=data.indexOf("base64,")+7;
                        setPrjData({...prjData,prj:{type:type,data:data.substring(idx)}});
                    };
                    fr.readAsDataURL(event.target.files[0]);
                }
            }
        }
        if(event.target.id=="trf")
        {
            if(event.target.files && event.target.files.length>0)
            {
                let size=event.target.files[0].size;
                let name=event.target.files[0].name;
                let type=event.target.files[0].type;
                if(size>=500*1024)
                {
                    alert("File Size should be less than<500KB !!");
                    event.target.value="";
                    return;
                }
                else if(!(type=="application/jpg" || type=="application/jpeg" || type=="application/png" || type=="application/pdf" || type=="application/msword" || type=="application/vnd.openxmlformats-officedocument.wordprocessingml.document"))
                {
                    alert("Only Word/PDF is valid!!!");
                    event.target.value="";
                    return;
                }
                else
                {
                    let fr=new FileReader();
                    fr.onloadend=(e)=>
                    {
                        let data=fr.result;
                        let idx=data.indexOf("base64,")+7;
                        setPrjData({...prjData,trf:{type:type,data:data.substring(idx)}});
                    };
                    fr.readAsDataURL(event.target.files[0]);
                }
            }
        }
        if(event.target.id=="rpt")
        {
            if(event.target.files && event.target.files.length>0)
            {
                let size=event.target.files[0].size;
                let name=event.target.files[0].name;
                let type=event.target.files[0].type;
                if(size>=500*1024)
                {
                    alert("File Size should be less than<500KB !!");
                    event.target.value="";
                    return;
                }
                else if(!(type=="application/jpg" || type=="application/jpeg" || type=="application/png" || type=="application/pdf" || type=="application/msword" || type=="application/vnd.openxmlformats-officedocument.wordprocessingml.document"))
                {
                    alert("Only Word/PDF is valid!!!");
                    event.target.value="";
                    return;
                }
                else
                {
                    let fr=new FileReader();
                    fr.onloadend=(e)=>
                    {
                        let data=fr.result;
                        let idx=data.indexOf("base64,")+7;
                        setPrjData({...prjData,rpt:{type:type,data:data.substring(idx)}});
                    };
                    fr.readAsDataURL(event.target.files[0]);
                }
            }
        }
        if(event.target.id=="raw")
        {
            if(event.target.files && event.target.files.length>0)
            {
                let size=event.target.files[0].size;
                let name=event.target.files[0].name;
                let type=event.target.files[0].type;
                if(size>=500*1024)
                {
                    alert("File Size should be less than<500KB !!");
                    event.target.value="";
                    return;
                }
                else if(!(type=="application/jpg" || type=="application/jpeg" || type=="application/png" || type=="application/pdf" || type=="application/msword" || type=="application/vnd.openxmlformats-officedocument.wordprocessingml.document"))
                {
                    alert("Only Word/PDF is valid!!!");
                    event.target.value="";
                    return;
                }
                else
                {
                    let fr=new FileReader();
                    fr.onloadend=(e)=>
                    {
                        let data=fr.result;
                        let idx=data.indexOf("base64,")+7;
                        setPrjData({...prjData,raw:{type:type,data:data.substring(idx)}});
                    };
                    fr.readAsDataURL(event.target.files[0]);
                }
            }
        }        
    }
    async function saveData(event)
    {
        event.preventDefault();
        if(prjData.sname.trim()=="")
        {
            alert("Sample Name is Missing!!!");
            event.target.sname.focus();
            return;
        }
        if(prjData.tid=="0")
        {
            alert("Select Test Name!!!");
            event.target.tname.focus();
            return;
        }
        if(prjData.cid=="0")
        {
            alert("Select Client Name!!!");
            event.target.cname.focus();
            return;
        }
        if(prjData.rdate=="")
        {
            alert("Receiving Date is Missing!!!");
            event.target.rdate.focus();
            return;
        }
        if(prjData.ddate=="")
        {
            alert("Delivery Date is Missing!!!");
            event.target.date.focus();
            return;
        }
        if(prjData.prj.type=="" && (prjData.sid=="0" || prjData.sid=="" ))
        {
            alert("Project Image is Missing!!!");
            event.target.prj.focus();
            return;
        }
        if(prjData.trf.type=="" && (prjData.sid=="0" || prjData.sid=="" ))
        {
            alert("TRF File is Missing!!!");
            event.target.trf.focus();
            return;
        }
        let config={headers:{"Content-Type":"application/json",}};        
        if(prjData.sid=="0")
        {
            let json=JSON.stringify({...prjData,status:"R"});
            await axios.post(process.env.REACT_APP_APIURL+"samples.php?opr=S",json).then(reply=>
            {
                if(reply.status==200 && reply.data.status=="OK")
                {
                    alert(reply.data.message);
                    getProjects(document.getElementById("dtStart").value,document.getElementById("dtEnd").value);
                    clearText();
                }
                else
                {
                    alert(reply.data.message);
                }
            });
        }
        if(prjData.sid!="0")
        {
            let json=JSON.stringify({...prjData,status:"R"});
            console.log(json);
            await axios.post(process.env.REACT_APP_APIURL+"samples.php?opr=U",json).then(reply=>
            {
                if(reply.status==200 && reply.data.status=="OK")
                {
                    alert(reply.data.message);
                    clearText();
                }
                else
                {
                    alert(reply.data.message);
                }
            });
        }
        await getProjects(document.getElementById("dtStart").value,document.getElementById("dtEnd").value);
    }
    async function deleteData(sid)
    {
        if(window.urole.toUpperCase()!="ADMINISTRATOR")
        {
            alert("Sorry!, You can't delete!!!!");
            return;
        }
        if(window.confirm("Are you sure?"))
        {
            let json=JSON.stringify({sid:sid});  
            let config={headers:{"Content-Type":"application/json",}};          
            await axios.post(process.env.REACT_APP_APIURL+"samples.php?opr=D",json).then(reply=>
            {
                if(reply.status==200 && reply.data.status=="OK")
                {
                    alert(reply.data.message);
                    clearText();
                }
            });
        }
        await getProjects(document.getElementById("dtStart").value,document.getElementById("dtEnd").value);
    }
    function editData(sid)
    {
        let result=projects.filter((e)=>e.sid==sid);
        if(result.length==1)
        {            
            setPrjData({...prjData,sid:result[0].sid,sname:result[0].sname,tid:result[0].tid,cid:result[0].cid,rdate:result[0].rdate.split("-").reverse().join("-"),ddate:result[0].ddate.split("-").reverse().join("-")});            
        }
    }
    async function completeData(sid)
    {
        if(window.confirm("You are Marking this Project as Complete.\nAre you sure?"))
        {
            let json=JSON.stringify({sid:sid});
            let config={headers:{"Content-Type":"application/json",}};
            await axios.post(process.env.REACT_APP_APIURL+"samples.php?opr=M",json).then(reply=>
            {
                if(reply.status==200 && reply.data.status=="OK")
                {
                    alert(reply.data.message);
                    setPrjData({sid:0,cid:0,tid:0,sname:"",rdate:"",ddate:"",status:"",prj:{type:"",data:""},trf:{type:"",data:""},raw:{type:"",data:""},rpt:{type:"",data:""}});
                }
            });
        }
        await getProjects(document.getElementById("dtStart").value,document.getElementById("dtEnd").value);
    }
    function getDownloadURL(sid,rtype)
    {
        return(
            <a href={process.env.REACT_APP_APIURL+"download.php?tbl=smp&fl="+rtype+"&id="+sid}>Download</a>
        );
    }
    useEffect(()=>{
        getClients();
        getTests();        
        let d=new Date();
        document.getElementById("dtEnd").value=(d.getYear()+1900)+"-"+(d.getMonth()+1<10?"0"+(d.getMonth()+1):(d.getMonth()+1))+"-"+(d.getDate()<10?"0"+d.getDate():d.getDate());
        let d1=new Date();        
        d1.setMonth(d.getMonth()-1);
        document.getElementById("dtStart").value=(d1.getYear()+1900)+"-"+(d1.getMonth()+1<10?"0"+(d1.getMonth()+1):(d1.getMonth()+1))+"-"+(d1.getDate()<10?"0"+d1.getDate():d1.getDate());
        getProjects(document.getElementById("dtStart").value,document.getElementById("dtEnd").value);
    },[]);
    return(
                
        <div className="container">
            <div className="mt-3">
                <form onSubmit={saveData}>
                    <div className="card shadow">
                        <div className="card-header text-center bg-primary text-white h5">Sample Collection</div>
                        <div className="card-body">
                            <div className="row">
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                                    <label>Sample Name</label>
                                    <input id="sname" type="text" value={prjData.sname} onChange={testChanged} className="form-control form-control-sm" />
                                </div>
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                                    <label>Test Name</label>
                                    <select id="tname"  onChange={testChanged} className="form-control form-control-sm" >
                                        <option value="0">Select Test</option>
                                        {tests.map((e)=><option value={e.tid} selected={e.tid==prjData.tid}>{e.testname}</option>)}
                                    </select>
                                </div>
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                                    <label>Client Name</label>
                                    <select id="cname"  onChange={testChanged} className="form-control form-control-sm" >
                                        <option value="0">Select Client</option>
                                        {clients.map((e)=><option value={e.cid} selected={e.cid==prjData.cid}>{e.cname}</option>)}   
                                    </select>
                                </div>
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                                    <label>Receiving Date</label>
                                    <input id="rdate" value={prjData.rdate} onChange={testChanged} type="date" className="form-control form-control-sm" />
                                </div>
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                                    <label>Delivery Date</label>
                                    <input id="ddate" value={prjData.ddate} onChange={testChanged} type="date" className="form-control form-control-sm" />
                                </div>
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                                    <label>Project Image</label>
                                    <input id="prj" onChange={testChanged} type="file" className="form-control form-control-sm" />
                                </div>
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                                    <label>TRF File</label>
                                    <input id="trf"  onChange={testChanged} type="file" className="form-control form-control-sm" />
                                </div>
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                                    <label>Report File</label>
                                    <input id="rpt" onChange={testChanged} type="file" className="form-control form-control-sm" />
                                </div>
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                                    <label>Raw File</label>
                                    <input id="raw" onChange={testChanged} type="file" className="form-control form-control-sm" />
                                </div>
                            </div>
                            <input type="submit" value="Add/Update Sample" className="btn btn-primary mt-3" />
                            <input type="button" onClick={clearText} value="Clear" className="btn bg-info text-black mt-3 ms-3" />
                            <hr/>
                            <div style={{overflow:"auto"}} >
                                <div className="row">
                                    <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-6"><input type="Date" id="dtStart" onChange={(event)=>{getProjects(event.target.value,document.getElementById("dtEnd").value);}} className="form-control" /></div>
                                    <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-6"><input type="Date" id="dtEnd" onChange={(event)=>{getProjects(document.getElementById("dtStart").value,event.target.value,);}} className="form-control" /></div>
                                </div>
                                <table className="table table-bordered table-striped mt-2">
                                    <thead>
                                        <tr>
                                            <th>S.No.</th>
                                            <th>Sample</th>
                                            <th>Test</th>
                                            <th>Client</th>
                                            <th>Receiving Date</th>
                                            <th>Delivery Date</th>
                                            <th>Project Image</th>
                                            <th>TRF File</th>
                                            <th>Report File</th>
                                            <th>Raw Data File</th>
                                            <th>Current Status</th>
                                            <th>Edit</th>
                                            <th>Delete</th>
                                            <th>Change Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {projects.map((e,i)=>
                                            <tr>
                                                <td>{i+1}</td>
                                                <td>{e.sname}</td>
                                                <td>{e.tname}</td>
                                                <td>{e.cname}</td>
                                                <td>{e.rdate}</td>
                                                <td>{e.ddate}</td>
                                                <td>{e.prjtype=="" || e.prjtype==null?"No File":getDownloadURL(e.sid,"prj")}</td>
                                                <td>{e.trftype=="" || e.trftype==null?"No File":getDownloadURL(e.sid,"trf")}</td>
                                                <td>{e.reporttype=="" || e.reporttype==null?"No File":getDownloadURL(e.sid,"rpt")}</td>
                                                <td>{e.rawtype=="" || e.rawtype==null?"No File":getDownloadURL(e.sid,"raw")}</td>
                                                <td className={e.status=="Completed"?"bg-success text-white rounded-4":(e.status=="Running"?"bg-info text-black  rounded-4":"bg-danger text-white  rounded-4")}>{e.status}</td>
                                                <td><img src={ediimg} onClick={()=>{editData(e.sid);}} style={{width:'35px',cursor:'pointer'}} /></td>
                                                <td><img src={delimg} onClick={()=>{deleteData(e.sid);}} style={{width:'35px',cursor:'pointer'}} /></td>
                                                <td><img src={comimg} onClick={()=>{completeData(e.sid);}} style={{width:'35px',cursor:'pointer'}} /></td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="card-footer bg-primary"></div>
                    </div>
                </form>
            </div>
        </div>
        
    );
}
export default Projects;